import { render, staticRenderFns } from "./BrokerList.vue?vue&type=template&id=7b949d2b&scoped=true"
import script from "./BrokerList.vue?vue&type=script&lang=js"
export * from "./BrokerList.vue?vue&type=script&lang=js"
import style0 from "./BrokerList.vue?vue&type=style&index=0&id=7b949d2b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b949d2b",
  null
  
)

export default component.exports